<template>
 <div class="website-list">
 <div class="toolbar">
 <el-input
 v-model="keyword"
 placeholder="搜索网站名称或域名"
 prefix-icon="el-icon-search"
 clearable
 size="small"
 style="width:260px"
 @clear="loadList"
 @keyup.enter.native="loadList"
 />
 <el-button type="primary" size="small" @click="loadList" style="margin-left:12px">搜索</el-button>
 <el-button v-if="isSuper" type="success" size="small" icon="el-icon-plus" @click="$router.push('/website/create')">新增网站</el-button>
 </div>

 <div class="chart-card">
 <el-table :data="list" v-loading="loading" stripe style="width:100%">
 <el-table-column type="index" label="#" width="60" />
 <el-table-column prop="name" label="网站名称" min-width="150" />
 <el-table-column prop="domain" label="域名" min-width="200" />
 <el-table-column label="状态" width="100">
 <template slot-scope="{row}">
 <el-tag :type="row.status ? 'success' : 'danger'" size="small" effect="light">
 {{ row.status ? '启用' : '禁用' }}
 </el-tag>
 </template>
 </el-table-column>
 <el-table-column prop="today_visits" label="今日访问" width="100" sortable />
 <el-table-column prop="total_visits" label="总访问量" width="100" sortable />
 <el-table-column label="追踪链接" min-width="300">
 <template slot-scope="{row}">
 <el-input
 :value="row.tracker_url"
 readonly
 size="mini"
 style="width:280px"
 >
 <el-button slot="append" icon="el-icon-document-copy" @click="copyText(row.tracker_url)">复制</el-button>
 </el-input>
 </template>
 </el-table-column>
 <el-table-column prop="created_at" label="创建时间" width="160">
 <template slot-scope="{row}">{{ row.created_at }}</template>
 </el-table-column>
 <el-table-column label="操作" width="220" fixed="right">
 <template slot-scope="{row}">
 <el-button type="text" size="small" @click="$router.push('/website/stats/' + row.id)">统计</el-button>
 <el-button type="text" size="small" @click="showEmbed(row)">嵌入代码</el-button>
 <el-button v-if="isSuper" type="text" size="small" @click="$router.push('/website/edit/' + row.id)">编辑</el-button>
 <el-button v-if="isSuper" type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
 </template>
 </el-table-column>
 </el-table>

 <div class="pagination">
 <el-pagination
 @current-change="handlePageChange"
 :current-page="page"
 :page-size="pageSize"
 :total="total"
 layout="total, prev, pager, next"
 />
 </div>
 </div>

 <el-dialog title="嵌入代码" :visible.sync="embedDialog" width="640px">
 <p class="embed-tip">将以下代码放置在网站页面的 <code>&lt;head&gt;</code> 或 <code>&lt;/body&gt;</code> 之前：</p>
 <el-input type="textarea" :value="embedCode" readonly :rows="3" id="embedCodeInput" />
 <div slot="footer">
 <el-button @click="embedDialog = false">关闭</el-button>
 <el-button type="primary" @click="copyText(embedCode)">复制代码</el-button>
 </div>
 </el-dialog>
 </div>
</template>

<script>
import { websiteApi } from '../api';

export default {
 name: 'WebsiteList',
 computed: {
 isSuper() {
 try {
 const u = JSON.parse(localStorage.getItem('wt_user') || '{}');
 return Number(u.is_super) === 1;
 } catch (e) { return false; }
 }
 },
 data() {
 return {
 list: [],
 loading: false,
 keyword: '',
 page: 1,
 pageSize: 10,
 total: 0,
 embedDialog: false,
 embedCode: ''
 };
 },
 mounted() {
 this.loadList();
 },
 methods: {
 async loadList() {
 this.loading = true;
 try {
 const res = await websiteApi.list({ page: this.page, page_size: this.pageSize, keyword: this.keyword });
 if (res.code === 0) {
 this.list = res.data.list;
 this.total = res.data.total;
 }
 } catch (e) {
 this.$message.error('加载失败');
 } finally {
 this.loading = false;
 }
 },
 handlePageChange(p) {
 this.page = p;
 this.loadList();
 },
 showEmbed(row) {
 this.embedCode = '<script src="' + row.tracker_url + '" async defer><\/script>';
 this.embedDialog = true;
 },
 async handleDelete(row) {
 try {
 await this.$confirm('确认删除网站「' + row.name + '」及其所有访问数据？', '删除确认', { type: 'warning' });
 const res = await websiteApi.delete(row.id);
 if (res.code === 0) {
 this.$message.success('删除成功');
 this.loadList();
 } else {
 this.$message.error(res.msg);
 }
 } catch (e) {
 if (e !== 'cancel') this.$message.error('删除失败');
 }
 },
 copyText(text) {
 const input = document.createElement('textarea');
 input.value = text;
 document.body.appendChild(input);
 input.select();
 try {
 document.execCommand('copy');
 this.$message.success('已复制到剪贴板');
 } catch (e) {
 this.$message.error('复制失败');
 }
 document.body.removeChild(input);
 }
 }
};
</script>

<style scoped>
.toolbar {
 display: flex;
 align-items: center;
 margin-bottom: 18px;
 gap: 8px;
}

.chart-card {
 background: #fff;
 border-radius: 8px;
 box-shadow: 0 1px 3px rgba(0,0,0,0.04);
 border: 1px solid #eef0f3;
 overflow: hidden;
}

.pagination {
 padding: 14px 20px;
 text-align: right;
}

.embed-tip {
 font-size: 14px;
 color: #64748b;
 margin-bottom: 12px;
 line-height: 1.6;
}

.embed-tip code {
 background: #f5f7fa;
 padding: 2px 6px;
 border-radius: 4px;
 color: #d4905a;
 font-family: 'SF Mono', monospace;
}
</style>